import React, { useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getAnonUserId, getHostName, slugifyText } from "../helpers/utils";
import axios from "axios";

import Header from "../components/Header";
// import ProductsList from "./ProductsList";
// import Banner1 from "./Banner1";
// import BeforeAfter from "./BeforeAfter";
// import Services from "./Services";
// import Testemonials from "./Testemonials";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import Loader from "../components/Loader";
// import Blog from "./Blog";
// import BannerSlider from "../components/BannerSlider";
// import OfferSlider from "../components/OfferSlider";
import CartSidebar from "../components/CartSidebar";
import WishlistModal from "../components/WishlistModal";
import SearchOffcanvas from "../components/SearchOffcanvas";
// import ProductsModal from "./ProductsModal";
import BlogsModal from "./BlogsModal";
import AffiliateModal from "./AffiliateModal";
// import { toast } from "react-toastify";
import Home from "./Home";

export default function UserLayout() {
  let hostname = getHostName();
  const rlocation = useLocation();

  const [cartOffcanvasToggle, setCartOffcanvasToggle] = React.useState(false);

  const handleCloseOffcanvas = () => setCartOffcanvasToggle(false);
  const handleShowOffcanvas = () => setCartOffcanvasToggle(true);

  const [wishlistModalToggle, setWishlistModalToggle] = React.useState(false);

  const handleCloseWishlistModal = () => setWishlistModalToggle(false);
  const handleShowWishlistModal = () => setWishlistModalToggle(true);

  const [searchOffcanvasToggle, setSearchOffcanvasToggle] =
    React.useState(false);

  const handleCloseOffcanvasSearch = () => setSearchOffcanvasToggle(false);
  const handleShowOffcanvasSearch = () => setSearchOffcanvasToggle(true);

  // const [showProductsModal, setShowProductsModal] = React.useState(false);

  // const handleCloseProductsModal = () => setShowProductsModal(false);
  // const handleShowProductsModal = () => setShowProductsModal(true);

  const [showBlogsModal, setShowBlogsModal] = React.useState(false);

  const handleCloseBlogsModal = () => setShowBlogsModal(false);
  const handleShowBlogsModal = () => setShowBlogsModal(true);

  const [showAffiliateModal, setShowAffiliateModal] = React.useState(false);

  const handleCloseAffiliateModal = () => setShowAffiliateModal(false);
  const handleShowAffiliateModal = () => setShowAffiliateModal(true);

  const [mainLoader, setMainLoader] = React.useState(true);

  // cart list
  // const [cartList, setCartList] = React.useState([]);
  // const [cartListCounter, setCartListCounter] = React.useState(0);

  // wish list
  // const [wishList, setWishList] = React.useState([]);
  // const [wishListCounter, setWishListCounter] = React.useState(0);

  // imgs
  const [bannerImages, setBannerImages] = React.useState([]);

  // imgs50
  const [banner50Images, setBanner50Images] = React.useState([]);

  // products
  const [productsList, setProductsList] = React.useState([]);

  //testimonials
  const [testimonialsList, setTestimonialsList] = React.useState([]);

  //blogs
  const [blogsList, setBlogsList] = React.useState([]);

  const [payload, setPayload] = React.useState({});

  // const [cartLoader, setCartLoader] = React.useState(false);

  // ############################# smooth scroolling ##############################

  const homeRef = useRef(null);
  const productsRef = useRef(null);
  const bundlesRef = useRef(null);
  const blogsRef = useRef(null);

  const scrollToSection = (ref) => {
    console.log(ref);
    if (typeof ref === "object" && ref.current)
      ref.current.scrollIntoView({ behavior: "smooth" });
  };

  const normalizeApiList = (payload) => {
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload)) return payload;
    return [];
  };

  // ##########################  methods  ###########################

  const getAllBannerImages = () => {
    axios
      .get(`${hostname}/api/banners/get-all-banners`)
      .then((res) => {
        console.log(res.data);
        let arr = [];
        const banners = normalizeApiList(res.data);

        for (let i = 0; i < banners.length; i++) {
          const element = banners[i];

          if (element.status) {
            // if banner is active
            let obj = {};
            obj.imageUrl = element.imageUrl;
            obj.order = element.order;
            arr.push(obj);
          }
        }

        console.log(arr);

        setBannerImages(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllBanner50Images = () => {
    axios
      .get(`${hostname}/api/banners50/get-all-banners50`)
      .then((res) => {
        console.log(res.data);
        let arr = [];
        const banners = normalizeApiList(res.data);

        for (let i = 0; i < banners.length; i++) {
          const element = banners[i];

          if (element.status) {
            // if banner is active
            let obj = {};
            obj.imageUrl = element.imageUrl;
            obj.order = element.order;
            arr.push(obj);
          }
        }

        console.log(arr);

        setBanner50Images(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllProductsList = () => {
    axios
      .get(`${hostname}/api/products/get-all-products`)
      .then((res) => {
        console.log(res.data);
        let arr = normalizeApiList(res.data).filter((v) => v.status);
        console.log(arr);

        setProductsList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllTestimonialsList = () => {
    axios
      .get(`${hostname}/api/testimonials/get-all-testimonials`)
      .then((res) => {
        console.log(res.data);
        let arr = normalizeApiList(res.data).filter((v) => v.status);
        console.log(arr);

        setTestimonialsList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllBlogsList = () => {
    axios
      .get(`${hostname}/api/blogs/get-all-blogs`)
      .then((res) => {
        console.log(res.data);
        let arr = normalizeApiList(res.data).filter((v) => v.status);
        console.log(arr);

        setBlogsList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const getAllCartListData = () => {
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/cart/get`, {
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       let arr = [];
  //       arr = res.data.filter((v) => v.status);
  //       console.log(arr);

  //       setCartList(arr);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const getAllWishListData = () => {
  //   let anonUserId = getAnonUserId();
  //   if (anonUserId)
  //     axios
  //       .post(`${hostname}/api/wishlist/get-wishlist`, {
  //         annoUserDeviceId: anonUserId,
  //       })
  //       .then((res) => {
  //         console.log(res.data);
  //         let arr = [];
  //         arr = res.data.filter((v) => v.status);
  //         console.log(arr);

  //         setWishList(arr);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  // };

  React.useEffect(() => {
    if (rlocation.pathname === "/") {
      getAllBannerImages();
      getAllProductsList();
      getAllBanner50Images();
      getAllTestimonialsList();
      getAllBlogsList();
      // getAllCartListData();
      // getCartCounterData();
      // getAllWishListData();
      // getWishlistCounterData();
    }
    setTimeout(() => {
      setMainLoader(false);
    }, 500);
  }, []);

  // const navigate = useNavigate();

  const handleNavigateToLogin = () => {
    window.open(`${window.location.origin}/login`, "_blank");
  };

  // const handleNavigateToCheckOut = (cartList) => {
  //   // UPDATE IN DB
  //   setCartLoader(true);

  //   let anonUserId = getAnonUserId();

  //   axios
  //     .post(`${hostname}/api/cart/bulk-update`, {
  //       annoUserDeviceId: anonUserId,
  //       items: cartList,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setTimeout(() => {
  //         setCartLoader(false);
  //       }, 800);
  //       setTimeout(() => {
  //         navigate("/checkout");
  //       }, 1000);

  //       // toast.success("Items updated.", { theme: "colored" });
  //       console.log("database updated");
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setCartLoader(false);
  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // view product
  const viewProduct = (product) => {
    // using new page for products
    // window.location.href = `/${obj.title}?pid=${obj._id}`;
    localStorage.setItem("productId", product._id); // save ID
    window.location.href = `/${slugifyText(product.title)}`;
    // obj.loadType = "View Product";
    // setPayload({ ...obj });
    // handleShowProductsModal();
  };

  // view blog
  const viewBlog = (obj) => {
    obj.loadType = "View Blog";
    setPayload({ ...obj });
    handleShowBlogsModal();
  };

  // const addItemtoCart = (p_id, quantity = 1) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/cart/add`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //       quantity,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setCartListCounter(cartListCounter + 1);
  //       getAllCartListData();

  //       toast.success("Product Added to Cart.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const removeItemtoCart = (p_id) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/cart/remove`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setCartListCounter(cartListCounter - 1);

  //       getAllCartListData();

  //       toast.warning("Product removed to cart.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const getCartCounterData = () => {
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .get(`${hostname}/api/cart/count?annoUserDeviceId=${anonUserId}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       setCartListCounter(res.data.count);
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const addItemtoWishlist = (p_id) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();

  //   axios
  //     .post(`${hostname}/api/wishlist/add-in-wishlist`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setWishListCounter(wishListCounter + 1);
  //       getAllWishListData();

  //       toast.success("Product Added to Wishlist.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const removeItemtoWishlist = (p_id) => {
  //   if (!p_id) return;
  //   let anonUserId = getAnonUserId();
  //   axios
  //     .post(`${hostname}/api/wishlist/remove-from-wishlist`, {
  //       product_id: p_id,
  //       annoUserDeviceId: anonUserId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setWishListCounter(wishListCounter - 1);

  //       getAllWishListData();

  //       toast.warning("Product removed to Wishlist.", { theme: "colored" });
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const getWishlistCounterData = () => {
  //   let anonUserId = getAnonUserId();

  //   axios
  //     .get(
  //       `${hostname}/api/wishlist/get-wishlist-count?annoUserDeviceId=${anonUserId}`
  //     )
  //     .then((res) => {
  //       console.log(res.data);
  //       setWishListCounter(res.data.count);
  //     })
  //     .catch((err) => {
  //       console.log(err);

  //       if ("response" in err)
  //         toast.error(err.response.data.error, { theme: "colored" });
  //       else toast.error("something went wrong!", { theme: "colored" });
  //     });
  // };

  // const updateQuantity = (productId, newQty) => {
  //   if (newQty < 1) return;

  //   const updatedCart = cartList.map((item) => {
  //     if (item.product._id === productId) {
  //       return { ...item, quantity: newQty };
  //     }
  //     return item;
  //   });

  //   setCartList(updatedCart);
  // };

  // ####################################  Affilitate  ##################################

  const applyForAffiliateProgram = (obj) => {
    obj.loadType = "Apply for Affiliate";
    setPayload({ ...obj });
    handleShowAffiliateModal();
  };

  // ####################################  return statements  ##################################

  if (mainLoader) return <Loader />;
  return (
    <>
      {/* Header */}
      <Header
        handleShowOffcanvas={handleShowOffcanvas}
        handleShowWishlistModal={handleShowWishlistModal}
        handleShowOffcanvasSearch={handleShowOffcanvasSearch}
        handleNavigateToLogin={handleNavigateToLogin}
        homeRef={homeRef}
        productsRef={productsRef}
        bundlesRef={bundlesRef}
        blogsRef={blogsRef}
        scrollToSection={scrollToSection}
        // cartListCounter={cartListCounter}
        // wishListCounter={wishListCounter}
      />

      {/* ############# dynamic section start ########### */}
      <br />
      {rlocation.pathname === "/" ? (
        <Home
          bannerImages={bannerImages}
          homeRef={homeRef}
          productsList={productsList}
          viewProduct={viewProduct}
          productsRef={productsRef}
          // addItemtoCart={addItemtoCart}
          // removeItemtoCart={removeItemtoCart}
          // cartList={cartList}
          // addItemtoWishlist={addItemtoWishlist}
          // removeItemtoWishlist={removeItemtoWishlist}
          // wishList={wishList}
          bundlesRef={bundlesRef}
          banner50Images={banner50Images}
          testimonialsList={testimonialsList}
          blogsList={blogsList}
          blogsRef={blogsRef}
          viewBlog={viewBlog}
        />
      ) : (
        <Outlet />
      )}

      {/* ############# dynamic section end ########### */}

      {/* Footer */}
      <Footer
        applyForAffiliateProgram={applyForAffiliateProgram}
        productsRef={productsRef}
        bundlesRef={bundlesRef}
      />

      {/* Backtotop */}
      <BackToTop />

      {/* Card Sidebar */}
      <CartSidebar
        show={cartOffcanvasToggle}
        handleClose={handleCloseOffcanvas}
        // cartList={cartList}
        // removeItemFromCart={removeItemtoCart}
        // updateQuantity={updateQuantity}
        // handleNavigateToCheckOut={handleNavigateToCheckOut}
        // cartLoader={cartLoader}
      />
      <br />
      <WishlistModal
        show={wishlistModalToggle}
        handleClose={handleCloseWishlistModal}
        // wishList={wishList}
        // removeItemtoWishlist={removeItemtoWishlist}
      />
      <br />
      <SearchOffcanvas
        show={searchOffcanvasToggle}
        handleClose={handleCloseOffcanvasSearch}
        dataList={productsList}
        onSelect={viewProduct}
      />
      {/* <br />
      <ProductsModal
        show={showProductsModal}
        handleClose={handleCloseProductsModal}
        payload={payload}
        setPayload={setPayload}
         addItemtoCart={addItemtoCart}
         removeItemtoCart={removeItemtoCart}
         cartList={cartList}
        getAllCartListData={getAllCartListData}
      /> */}
      <br />
      <BlogsModal
        show={showBlogsModal}
        handleClose={handleCloseBlogsModal}
        payload={payload}
        setPayload={setPayload}
      />
      <br />
      <AffiliateModal
        show={showAffiliateModal}
        handleClose={handleCloseAffiliateModal}
        payload={payload}
        setPayload={setPayload}
      />
    </>
  );
}
